import { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import taskContext from "../task.context";
import Tasks from "./Tasks";

const Main = () => {
  const { SAP_ID } = useParams();

  const { officers } = useSelector((state) => state.officers);

  const { officer, setOfficer, plan, planDate } = useContext(taskContext);

  useEffect(() => {
    if (!SAP_ID || !officers?.length) return;

    const officer = officers.filter((item) => item.SAP_ID === SAP_ID);

    setOfficer(officer[0]);
  }, [officers]);

  return (
    <div
      className="main-ctr"
      style={{ marginRight: "1rem", marginTop: "-3rem" }}
    >
      <div className="calendar-bar">
        <div className="info-bar">
          <div className="officer-details">
            <div className="o-name">SAP_ID : {officer?.SAP_ID} </div>
            <div> Territory : {officer?.SAP_ID} </div>
          </div>
        </div>
      </div>
      <Tasks />
    </div>
  );
};

export default Main;
